import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _regeneratorRuntime from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'store';
import { spaceActions } from 'store/space';
import { GetBranchesAPI, GetAllBranchesAPI } from 'api/space';

var ClusterMenu = function ClusterMenu(_ref) {
  var selected = _ref.selected;
  var dispatch = useDispatch();
  var regions = useSelector(function (state) {
    return state.space.regions;
  }).results;
  useEffect(function () {
    return function () {};
  }, []);

  var clickMenu = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var cluster, _yield$GetAllBranches, data, region, _yield$GetBranchesAPI, _data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cluster = e.target.text;
              clearMenu(cluster);

              if (!(cluster === '전체')) {
                _context.next = 10;
                break;
              }

              _context.next = 5;
              return GetAllBranchesAPI();

            case 5:
              _yield$GetAllBranches = _context.sent;
              data = _yield$GetAllBranches.data;
              dispatch(spaceActions.getBranches(_objectSpread(_objectSpread({}, data), {}, {
                region: 'ALL'
              })));
              _context.next = 16;
              break;

            case 10:
              region = findClusterID(cluster);
              _context.next = 13;
              return GetBranchesAPI(region);

            case 13:
              _yield$GetBranchesAPI = _context.sent;
              _data = _yield$GetBranchesAPI.data;
              dispatch(spaceActions.getBranches(_objectSpread(_objectSpread({}, _data), {}, {
                region: cluster
              })));

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function clickMenu(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var findClusterID = function findClusterID(cluster) {
    return regions.filter(function (region) {
      if (region.name === cluster) return region;
    })[0].id;
  };

  var clearMenu = function clearMenu(cluster) {
    var menu = document.getElementById('clusterMenu');
    menu.querySelectorAll('li').forEach(function (element) {
      var aTag = element.firstElementChild;

      if (aTag.textContent === cluster) {
        element.className = 'selected';
      } else {
        element.classList.remove('selected');
      }
    });
  };

  return /*#__PURE__*/_jsx("div", {
    className: "s-menu",
    id: "clusterMenu",
    children: /*#__PURE__*/_jsxs("ul", {
      children: [selected === 'ALL' ? /*#__PURE__*/_jsx("li", {
        className: "selected",
        onClick: clickMenu,
        children: /*#__PURE__*/_jsx("a", {
          children: "\uC804\uCCB4"
        })
      }) : /*#__PURE__*/_jsx("li", {
        onClick: clickMenu,
        children: /*#__PURE__*/_jsx("a", {
          children: "\uC804\uCCB4"
        })
      }), regions.map(function (region) {
        if (region.name === selected) {
          return /*#__PURE__*/_jsx("li", {
            className: "selected",
            onClick: clickMenu,
            children: /*#__PURE__*/_jsx("a", {
              children: region.name
            })
          }, region.id);
        }

        return /*#__PURE__*/_jsx("li", {
          onClick: clickMenu,
          children: /*#__PURE__*/_jsx("a", {
            children: region.name
          })
        }, region.id);
      })]
    })
  });
};

export default ClusterMenu;